<template>
  <ActionDropdown :actions="actions" :cssClass="cssClass" />

  <UserProfileActionModal ref="UserProfileActionModal"
    @setUserProfiles="$refs['UserProfileGroupedModal'].show($event.user, $event.application.id)" />
  <UserProfileGroupedModal ref="UserProfileGroupedModal"
    @setExpirations="$refs['UserProfileGroupedExpirationsModal'].show($event)" />
  <UserProfileGroupedExpirationsModal ref="UserProfileGroupedExpirationsModal" @updated="$emit('created', $event)" />
  <ImportModal ref="ImportModal" @created="$emit('created', $event)" endpoint="users/profiles/import"
    :name="i18n('User Profiles')" :columns="[
      'user_origin',
      'origin_identifier',
      'application',
      'profile',
      'status',
      'applicationUsername',
    ]" />
</template>
<script>
import api from "@/api";
import ImportModal from "@/components/common/import/ImportModal.vue";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";
import UserProfileActionModal from "@/components/userProfile/UserProfileActionModal.vue";
import UserProfileGroupedModal from "@/components/userProfile/UserProfileGroupedModal.vue";
import UserProfileGroupedExpirationsModal from "@/components/userProfile/UserProfileGroupedExpirationsModal.vue";

export default {
  components: {
    ImportModal,
    ActionDropdown,
    UserProfileActionModal,
    UserProfileGroupedModal,
    UserProfileGroupedExpirationsModal,
  },
  props: {
    cssClass: String,
  },
  data() {
    return {
      formData: {},
    };
  },
  emits: [
    'added',
    'created'
  ],
  computed: {
    actions() {
      return [
        {
          label: this.i18n('Add New'),
          fn: () => {
            this.$refs['UserProfileActionModal'].show();
          },
          starred: true,
        },
        {
          label: this.i18n('Export'),
          fn: () => {
            api.getFile('users/profiles/export', {}, 'User Profiles.xlsx');
          },
          if: this.can('EXPORT_MANAGE'),
        },
        {
          label: this.i18n('Import'),
          fn: () => {
            this.$refs['ImportModal'].show();
          },
          if: this.can('IMPORT_MANAGE'),
        },
      ];
    },
  },
  methods: {
  },
};
</script>